const setEmployee = ({ commit }, employee) => {
    commit('SET_EMPLOYEE', employee)
}
const setValidEmployee = ({ commit }, boolean) => {
    commit('SET_VALID_EMPLOYEE', boolean)
}
const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    resetState,
    setEmployee,
    setValidEmployee,
}
